import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IApp } from '@core/models/app.interfaces';
import { environment } from '@env/environment';
import {
  CCR_CURRENT_STEP_KEY,
  CCR_DATA_KEY,
  CCR_STEP_COMPONENTS, CCR_TYPE,
  CHARGING_SITE_DOWNLOAD_URI,
} from '@module/credit-creation-reports/const/credit-creation-reports.const';
import {
  ICreditCreationReport,
  ICreditCreationReportGetAlphNumCI,
  ICreditCreationReportGetFacilityPayload,
  ICreditCreationReportPayload,
} from '@module/credit-creation-reports/credit-creation-reports.types';
import { BaseStepperService } from '@shared/components/base-stepper/base-stepper.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { FilterModel } from '@core/models/filter.model';
import { HelperService } from '@shared/services/helper.service';
import { IProject } from '@shared/services/project.service.types';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { DEFAULT_DIALOG_CONFIG, SereviceMessageType } from '@core/constants/serviceMessage.const';
import { ModalService } from '@shared/services/modal.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { StoreService } from '@core/store/store.service';
import { LOOKUP_ENERGY_EFFICIENCY_FOR_ANNUAL_STEP } from '@core/services/lookup.service';
import { downloadBlob } from '@core/utilities/utilities.constants';
import { sortBy } from 'lodash';
import { UploadDocumentService } from '@shared/services/upload-document.service';
import { ReleaseReportService } from '@core/services/release.report.service';
import { CAR_UNDER_SECTION_ELIGIBILITY_PROPERTY } from '@module/credit-adjustment-report/const/credit-adjustment-report.const';
import { CCR_INVOLVED_IN_ACTIVITIES } from '../routines/create-credis-reports.constats';

export const NEW_CREDIT_CREATION_REPORT_URI = '/cfr-service/creditCreationReport/getNewCreditCreationReport';
export const CCR_FACILITIES_URI = '/cfr-service/creditCreationReport/getFacilities';
export const CCR_CARBON_INTENSITY_IDS_LOOKUP_URI = '/cfr-service/application/lookupCarbonIntensityIDs';
export const CCR_CARBON_INTENSITY_ACTUAL_IDS_LOOKUP_URI = '/cfr-service/lookup/lookupActualCarbonIntensityIDs';
export const CCR_FUEL_ENERGY_DENSITY_URI = '/account-service/energyDensity/getForFuel';
export const CCR_CREDIT_TYPE_REPLACEMENT_URI = '/cfr-service/creditCreationReport/getCreditTypeForFuelType';
export const CCR_FEEDSTOCK_TYPE_URI = '/account-service/application/getForCCRLookup';
export const CAR_CI_PATHWAY_REPORT_DATA_URI ='/account-service/ciPathwayReport/get'
export const CCR_APPLICATION_DETAILS_URI = CCR_FEEDSTOCK_TYPE_URI;
export const CCR_REFERENCE_CARBON_INTENSITY = '/cfr-service/creditCreationReport/getReferencedCarbonIntensity';
export const CCR_REFERENCE_CARBON_INTENSITY_FOR_FUEL = '/cfr-service/creditCreationReport/getReferencedCarbonIntensityForFuel';
export const CCR_STEP_DETAILS = '/cfr-service/creditCreationReport/pageSearchCreditCreationReportDetail';
export const CCR_GET_REFERENCE_CI_ELECTRICITY = '/cfr-service/creditCreationReport/getReferencedCarbonIntensityForElectricity/';

export const CCR_SAVE_REPORT = '/cfr-service/creditCreationReport/saveCreditCreationReport';
export const CCR_SUBMIT_REPORT = '/cfr-service/creditCreationReport/submitCreditCreationReport';
export const CCR_RE_SUBMIT_REPORT = '/cfr-service/creditCreationReport/reSubmitCreditCreationReport';
export const CCR_SAVE_AND_PROCEED = '/cfr-service/creditCreationReport/saveAndProceedCreditCreationReport';
export const CCR_APPROVED_CARBONINTENSITIES = '/cfr-service/creditCreationReport/getApprovedCarbonIntensity/';
export const CCR_FUEL_REPLACEMENT_TYPE = '/cfr-service/creditCreationReport/getReplacementTypesForFuelType/';
export const CCR_UPDATE_STATUS = '/cfr-service/creditCreationReport/updateStatus';
export const CCR_DISCARDS = '/cfr-service/creditCreationReport/discard';
export const CCR_DOWNLOAD_REPORT = '/cfr-service/creditCreationReport/download/report/';

export const GET_FACILITY_DETAILS = '/account-service/cfrAccount/account/getFacilityDetail/';
export const GET_FOREIGN_SUPPLIER_DETAILS = '/account-service/account/getFacility/';
export const GET_REPORT_BY_ID = '/cfr-service/creditCreationReport/getReportById/';
export const GET_REPORT_BY_ID_AND_STEP = '/cfr-service/creditCreationReport/getReportByIdAndStep/';
export const GET_ACCR_BY_ID_AND_STEP = '/cfr-service/creditCreationReport/getAccr/';
export const GET_ACCR_Table_BY_ID_AND_STEP = '/cfr-service/creditCreationReport/pageSearchCreditCreationReportDetail';
export const GET_REPORT_BY_ID_TO_RESUBMIT = '/cfr-service/creditCreationReport/getReportToResubmit/';
export const REPORT_LIST_URI = '/cfr-service/creditCreationReport/pageSearchByFilter';
export const GET_FUELING_STATION = '/account-service/getFuelStation/';

export const CCR_PROJECT_LIST_FOR_ACCOUNT = '/cfr-service/creditCreationReport/getProjectListForAccount';
export const CCR_PROJECT_DETAILS = '/account-service/application/getErpEditedProject';
export const GET_CI_OF_REGISTRATION_REPORT = '/account-service/agreementTuc/findCIsForActiveAgreements/';
export const LOAD_AGREEMENT_BY_ID = '/account-service/agreementTuc/load/';
export const CREDIT_TRANSFER_DOWNLOAD_PDF = '/obps-service/creditAction/download/creditTransfer';

export const COMP_REP_DOC_UPLOAD_ID = '/cfr-service/complianceReport/getDocumentIdForReference';

export const CCR_PROPOSE = '/cfr-service/creditCreationReport/proposeCreditCreationReport';
export const CCR_GET_CI_DATA = '/cfr-service/creditCreationReport/getFinalCi';
export const CCR_GET_DEFAULTCIS = '/cfr-service/lookup/getDefaultCiForACCR';

export const CCR_VALIDATE_CI_PATHWAY = '/cfr-service/creditCreationReport/validatePwData';

@Injectable({
  providedIn: 'root',
})
export class CreditCreationReportsService extends BaseStepperService {

  public registrationReportsDetail: any;
  // public report: ICreditCreationReport;

  stepRoutineMap: any = {};

  private _refreshData$ = new Subject<any>();
  public refreshData$ = this._refreshData$.asObservable();

  private _callMethod$ = new BehaviorSubject<any>(null);
  public callMethod$ = this._callMethod$.asObservable();

  public currentStepInvalid = false;

  public verificationEnabled = false;
  public ccrUnderSectionEligibleYear : any;
  public hideOpaInfo: boolean;


  constructor(
    public http: HttpClient,
    public router: Router,
    public helperService: HelperService,
    public modalService: ModalService,
    public store: StoreService,
    public uploadDocumentService: UploadDocumentService,
    public releaseReportService: ReleaseReportService
  ) {
    super();
  }

  public callMethod(method: string, args: any = null) {
    this._callMethod$.next({method, args});
  }

  getNewCreditCreationReport(payload: ICreditCreationReportPayload): Observable<any> {
    return this.http.post(`${ environment.apiUrl }${ NEW_CREDIT_CREATION_REPORT_URI }`, payload);
  }

  getCCRStepDetails(reportId: number, stepCode: string) {
    const payload = { reportId, stepCode };
    return this.http.post<IApp.ILookup[]>(`${ environment.apiUrl }${ CCR_STEP_DETAILS }`, payload);
  }

  getFacilities(payload: ICreditCreationReportGetFacilityPayload) {
    return this.http.post(`${ environment.apiUrl }${ CCR_FACILITIES_URI }`, payload);
  }

  getAlphanumericIDofCI(payload: ICreditCreationReportGetAlphNumCI): Observable<IApp.ILookup[]> {
    return this.http.post<IApp.ILookup[]>(`${ environment.apiUrl }${ CCR_CARBON_INTENSITY_IDS_LOOKUP_URI }`, payload);
  }

  getActualAlphanumericIDofCI(payload: ICreditCreationReportGetAlphNumCI): Observable<IApp.ILookup[]> {
    return this.http.post<IApp.ILookup[]>(`${ environment.apiUrl }${ CCR_CARBON_INTENSITY_ACTUAL_IDS_LOOKUP_URI }`, payload);
  }

  getFeedstockRegion(id: number,actualCI=false) {
    let uri = actualCI ? CAR_CI_PATHWAY_REPORT_DATA_URI : CCR_FEEDSTOCK_TYPE_URI
    return this.http.get(`${ environment.apiUrl }${ uri }/${ id }`);
  }

  getApplicationDetails(id: number): Observable<any> {
    return this.http.get<any>(`${ environment.apiUrl }${ CCR_APPLICATION_DETAILS_URI }/${ id }`);
  }

  getFuelEnergyDensity(fuelId: number): Observable<IApp.ILookup[]> {
    return this.http.get<IApp.ILookup[]>(`${ environment.apiUrl }${ CCR_FUEL_ENERGY_DENSITY_URI }/${ fuelId }`);
  }

  getCreditTypeReplacement(type: string): Observable<IApp.ILookup[]> {
    return this.http.get<IApp.ILookup[]>(`${ environment.apiUrl }${ CCR_CREDIT_TYPE_REPLACEMENT_URI }/${ type }`);
  }

  getReferenceCarbonIntensity(year: number, fuelType: string): Observable<number> {
    return this.http.get(`${ environment.apiUrl }${ CCR_REFERENCE_CARBON_INTENSITY }/${ year }/${ fuelType.toUpperCase() }`)
      .pipe(map((response: IApp.ILookup) => Number(response.value)));
  }

  getCFRReferenceCarbonIntensity(year: number, fuelId: number): Observable<any> {
    return this.http.get(`${ environment.apiUrl }${ CCR_REFERENCE_CARBON_INTENSITY_FOR_FUEL }/${ year }/${ fuelId }`);
  }

  storeCurrentData() {
    const data = JSON.stringify({...this.currentData});
    sessionStorage.setItem(CCR_DATA_KEY, data);
    const currentStep = JSON.stringify(this.currentStep);
    sessionStorage.setItem(CCR_CURRENT_STEP_KEY, currentStep);
  }

  restoreCurrentData(skipRemove = false): any {
    const data = sessionStorage.getItem(CCR_DATA_KEY);
    if (data) {
      !skipRemove && sessionStorage.removeItem(CCR_DATA_KEY);
      return JSON.parse(data);
    } else {
      return null;
    }
  }

  restoreLastStep(): any {
      const currentStep = sessionStorage.getItem(CCR_CURRENT_STEP_KEY);
      if (currentStep) {
        sessionStorage.removeItem(CCR_CURRENT_STEP_KEY);
        return JSON.parse(currentStep);
      } else {
        return null;
      }
  }

  saveReport(payload, serviceUrl = false) {
    return this.http.post(`${ serviceUrl? environment.serviceUrl : environment.apiUrl }${CCR_SAVE_REPORT }`, {...payload, action: 'SAVE'})
  }

  saveAndProceed(payload, serviceUrl = false) {
    return this.http.post(`${ serviceUrl? environment.serviceUrl : environment.apiUrl }${CCR_SAVE_AND_PROCEED}`, {...payload, action: 'SAVE'})
  }

  getApprovedCarbonIntensities(complianceYear, fuelId, facilityName, reg = false, defaultCICode = null) {
    facilityName = facilityName.replace(/[^\w\s]/gi, '');
    let uri = `${CCR_APPROVED_CARBONINTENSITIES}${complianceYear}/${fuelId}/${facilityName}`;
    if (defaultCICode) {
      uri += `/${defaultCICode}`;
    }
    if (reg) {
      uri += '?reg=true';
    }
    return this.http.get(`${ environment.apiUrl }${uri}`);
  }

  getFuelReplacementType(fuelType):Observable<IApp.ILookup[]> {
    return this.http.get<IApp.ILookup[]>(`${ environment.apiUrl }${CCR_FUEL_REPLACEMENT_TYPE}${fuelType}`);
  }

  getFacilityDetails(facilityId, skipValidation = false): Observable<any> {
    let params = new HttpParams();
    params = params.append('skipValidation', `${skipValidation}`);
    return this.http.get<any>(`${ environment.apiUrl }${ GET_FACILITY_DETAILS }${facilityId}`, {params});
  }

  getEnergyEfficiencyForAnnualStep(stepCode: string) {
    return this.http.get<IApp.ILookup[]>(`${ environment.apiUrl }${ LOOKUP_ENERGY_EFFICIENCY_FOR_ANNUAL_STEP }/${ stepCode }`);
  }

  getForeignSupplierDetails(facilityId): Observable<any> {
    return this.http.get<any>(`${ environment.apiUrl }${ GET_FOREIGN_SUPPLIER_DETAILS }${facilityId}`);
  }

  getReportById(reportId, summary: boolean) {
    const uri = summary ? `${reportId}/${summary}`: `${reportId}`;
    return this.http.get<any>(`${ environment.apiUrl }${ GET_REPORT_BY_ID }${uri}`);
  }

  getReportByIdandStep(reportId, currentStepCode ,summary: boolean, serviceUrl = false){
    const uri = summary ? `${reportId}/${summary}`: `${reportId}/${currentStepCode}`;
    return this.http.get<any>(`${ serviceUrl? environment.serviceUrl : environment.apiUrl }${ GET_REPORT_BY_ID_AND_STEP }${uri}`);
  }

  getACCRByIdandStep(reportId, currentStepCode){
    const uri = `${reportId}/${currentStepCode}`;
    return this.http.get<any>(`${ environment.apiUrl }${ GET_ACCR_BY_ID_AND_STEP }${uri}`);
  }

  getACCRTableByIdandStep(pagination: IApp.IPagination, filterState: FilterModel = {}): Observable<any> {
    let params = new HttpParams();
    params = this.addPagination(params, pagination);
    filterState['reportId'] = this.currentData.id;
    filterState['stepCode'] = this.currentStep.code;

    return this.http.post<ICreditCreationReport>(`${environment.apiUrl}${ GET_ACCR_Table_BY_ID_AND_STEP }`, filterState, { params });
  }

  getCreditReportList(pagination: IApp.IPagination, filterState: FilterModel = {}): Observable<any> {
    let params = new HttpParams();
    params = this.addPagination(params, pagination);

    return this.http.post<ICreditCreationReport>(`${environment.apiUrl}${ REPORT_LIST_URI }`, filterState, { params });
  }

  triggerActionController(metadata: any, redirect = false) {
    const action = metadata.action;
    const payload = metadata.data;

    if (action.workflowAction === 'VIEW') {
      this.router.navigate(this.helperService.getTranslatedPath(`/credit-creation-reports/report/${payload.id}`));
    } else if (action.workflowAction === 'DOWNLOAD_CREDIT_CREATION_REPORT') {
      this.downloadDocument(payload.id);
    } else if (action.workflowAction === 'VIEW_VERIFICATION_DETAILS') {
      this.router.navigate(this.helperService.getTranslatedPath(`/verification/manage-verification/${payload.id}`));
    } else if (action.workflowAction === 'RESUBMIT') {
      if (payload.type === 'CREDIT_ADJUSTMENT') {
        this.router.navigate(this.helperService.getTranslatedPath(`/credit-adjustment-reports/report/${payload.id}/RESUBMIT`));
      } else {
        this.router.navigate(this.helperService.getTranslatedPath(`/credit-creation-reports/report/${payload.id}/RESUBMIT`));
      }
    } else if (action.workflowAction === 'SUBMIT_TO_ECCC_VERIFICATION_REPORT' || action.workflowAction === 'RESUBMIT_TO_ECCC_VERIFICATION_REPORT') {
      if (payload.type === 'CREDIT_ADJUSTMENT') {
        this.router.navigate(this.helperService.getTranslatedPath(`/credit-adjustment-reports/report/${payload.id}`));
      } else {
        this.router.navigate(this.helperService.getTranslatedPath(`/credit-creation-reports/report/${payload.id}`));
      }
    } else if (action.workflowAction === 'VIEW_VERIFICATION_REPORT') {
      this.router.navigate(this.helperService.getTranslatedPath(`/verification/report-summary/report-submission/${payload.verificationReportId}`));
    } else if (action.workflowAction === 'RELEASE_REPORT') {
       this.releaseReport(metadata.data, () => {
                this._refreshData$.next(true);
              });
    } else {
      this.executeAction(payload, action, redirect);
    }
  }

  getReferenceCarbonIntensityForFuel(year: number, fuelId: number): Observable<number> {
    return this.http.get(`${ environment.apiUrl }${ CCR_REFERENCE_CARBON_INTENSITY_FOR_FUEL }/${ year }/${ fuelId }`)
      .pipe(map((response: IApp.ILookup) => Number(response.value)));
  }

  public updateCCR(payload: any): Observable<IProject> {
    const uri = payload.action === 'DISCARD' ? CCR_DISCARDS : CCR_UPDATE_STATUS;
    return this.http.post<any>(`${environment.apiUrl}${uri}`, payload);
  }

  public downloadDocument(documentId) {
    const uri = environment.serviceUrl + CCR_DOWNLOAD_REPORT + documentId;
    this.http.get(uri, {observe: 'response', responseType: 'blob' as 'json'})
      .subscribe(
        (response: any) => downloadBlob(response),
        // () => this.http.get(uri, {observe: 'response'}).subscribe(),
      );
  }

  releaseReport(payload, onSuccess: ()=> void){
         const payloadForRelease = {
              "id": payload.id ,
              "entityName": payload.entityName,
              "type": payload.type
            }
            this.openConfirmationModal('confirmReleaseReport').subscribe((result?: any) => {
              if(result){
                this.releaseReportService.releaseReport(payloadForRelease).subscribe(response => {
                  if(response)
                  {
                    onSuccess();
                  }
                  });
                }
            });
  }

  executeAction(payload , action, redirect) {
    const request = {id: payload.id, action: action.workflowAction};
    const confirmationMessage = action.workflowAction === 'CREATE_NOTICE_OF_ERROR' ? 'confirmationMessageNOECreation' : payload.type !=='CREDIT_ADJUSTMENT' ?  'confirmationMessageCCReport' : 'confirmationMessageCAReport';
    const actionLabel = action.workflowAction;

    if (action.workflowAction === 'CREATE_NOTICE_OF_ERROR' ||
      action.workflowAction === 'CREATE_NOTICE_OF_SUSPENSION') {
      const uri = action.workflowAction === 'CREATE_NOTICE_OF_ERROR' ? '/notice-of-error' : '/notice-of-suspension';
      this.router.navigate(this.helperService.getTranslatedPath(uri),
        {state: { data: payload, formType: action.workflowAction }});
      return;
    }

    const sub$ = this.modalService.open(ServiceMessageComponent,
      {
        messages: null,
        message: confirmationMessage,
        metaDataList: [this.translateService.instant(`COMMON.actionsLabel.${actionLabel}`).toLowerCase(),
          payload.legalName,
        ],
        type: SereviceMessageType.WARNING,
      },
      true,
      DEFAULT_DIALOG_CONFIG,
    ).afterClosed().subscribe((result?: any) => {
      sub$.unsubscribe();
      if (result) {
        this.modalService.closeAllMessageDialogs();


        this.updateCCR(request).subscribe(response => {
          if (!redirect) {
            this._refreshData$.next(true);
          } else {
            this.resetStepper();
            this.store.back();
          }
        });
      }
    });
  }

  public getFuelingStation(orgId, stationId) {
    return this.http.get(`${ environment.apiUrl }${ GET_FUELING_STATION }${orgId}/${stationId}`);
  }

  public submitReport(payload) {
    return this.http.post<any>(`${environment.apiUrl}${CCR_SUBMIT_REPORT}`, {...payload, action: 'SUBMIT'});
  }

  public getProjectListForAccount(accountId: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}${CCR_PROJECT_LIST_FOR_ACCOUNT}/${accountId}`);
  }

  public getProjectDetails(projectId: number): Observable<any> {
    let url = `${environment.apiUrl}${CCR_PROJECT_DETAILS}/${projectId}`;
    if(!this.disabled && this.currentData.id) {
      url += `?ccrId=${this.currentData.id}`;
    }
    return this.http.get(url);
  }

  public openConfirmationModal(msg, yesNoButton = false) {
    return this.modalService
      .open(
        ServiceMessageComponent,
        {
          messages: null,
          message: msg,
          type: SereviceMessageType.WARNING,
          yesNoButton,
        },
        true,
        DEFAULT_DIALOG_CONFIG,
      )
      .afterClosed()
  }

  clearCallMethod(): void {
    this._callMethod$.next(null);
  }


  public showErrorMessage(message: string) {
    return this.modalService
      .open(
        ServiceMessageComponent,
        {
          messages: [
            {
              message: message,
            },
          ],
          message: message,
          type: SereviceMessageType.ERROR,
        },
        true,
        DEFAULT_DIALOG_CONFIG,
      )
      .afterClosed()
  }

  public showSuccessMessage(message:string){
    return this.modalService
      .open(
        ServiceMessageComponent,
        {
          messages: [
            {
              message: message,
            },
          ],
          message: message,
          type: SereviceMessageType.SUCCESS,
        },
        true,
        DEFAULT_DIALOG_CONFIG,
      )
      .afterClosed()
  }
  

  showWarning(message, metaDataList?) {
    return this.modalService.open(ServiceMessageComponent,
      {
        messages: null,
        message: message,
        metaDataList,
        type: SereviceMessageType.WARNING,
      },
      true,
      DEFAULT_DIALOG_CONFIG,
    ).afterClosed();
  }

  public getCarvonIntensitiesOfRegistrationReport(accountId, complianceYear) {
    return this.http.get(`${ environment.apiUrl }${ GET_CI_OF_REGISTRATION_REPORT }${accountId}/${complianceYear}`);
  }

  public getAgreementByID(id) {
    return this.http.get<any>(`${ environment.apiUrl}${LOAD_AGREEMENT_BY_ID}${id}`);
  }

  public fetchCCRUnderSectionEligibleYear(){
    let propertyUrl = CAR_UNDER_SECTION_ELIGIBILITY_PROPERTY
    return this.http.get<IApp.Property>(`${environment.apiUrl}${propertyUrl}`)
  }

  public isSubmittedBeforeCCROldFlag(): boolean {
    return this.hideOpaInfo;
  }

  public getReferencedCarbonIntensityForElectricity(province) {
    return this.http.get<any>(`${ environment.apiUrl}${CCR_GET_REFERENCE_CI_ELECTRICITY}${province}`);
  }

  public toggleCreditTransferStep(NILStepsCount) {
    if (NILStepsCount === 6) {
      this.steps = this.steps.filter(step => step.code !== 'STEP-7').map((step, index) => ({...step, id: index + 1}));
    } else if (this.steps.findIndex(step => step.code === 'STEP-7') === -1) {
      this.setReportSteps();
    }
  }

  public getSubStepContent(step, index, subStepIndex = null) {
    let component =  CCR_STEP_COMPONENTS.CREDIT_ADJUSTMENT_UNDER_SEC_DETAILS;
    let name = this.getStepName(step[this.translateService.currentLang]);
    if (step.code === 'STEP-SUB_SEC_90' || step.code === 'STEP-SUB_SEC_88' || step.code === 'STEP-SUB_SEC_9_3') {
      component = CCR_STEP_COMPONENTS.CREDIT_ADJUSTMENT_UNDER_SEC_DETAILS;
    }
    if (step.code === 'STEP-SUB_SEC_SUMMRY') {
      component = CCR_STEP_COMPONENTS.CREDIT_ADJUSTMENT_SUMMARY;
    }
    name = name.toLocaleLowerCase();
    const _step = {
      ...step,
      name: name.charAt(0).toUpperCase() + name.slice(1) ,
      skipTranslate: true,
      completed: false,
      id: index + 1,
      component,
    };
    _step.id = index + 1;
    _step.subId = subStepIndex+1;
    return _step;
  }

  public setReportSteps() {
    const steps = this.currentData.associatedSteps.map((step, index) => {

      const currentStepIdentifier = step.code.split('-')[1].trim();
      let component =  CCR_STEP_COMPONENTS.CREDIT_CREATION_REPORT_STEP;

      if ((this.currentData.type === CCR_TYPE.QUARTERLY && currentStepIdentifier === '9') || (this.currentData.type === CCR_TYPE.ANNUAL && currentStepIdentifier === '7')) {
        component = CCR_STEP_COMPONENTS.CREDIT_CREATION_CONTACT_PERSON;
      } else if ((this.currentData.type === CCR_TYPE.QUARTERLY && currentStepIdentifier === '10') || (this.currentData.type === CCR_TYPE.ANNUAL && currentStepIdentifier === '8')) {
        component = CCR_STEP_COMPONENTS.CREDIT_CREATION_VERIFICATION;
      } else if ((this.currentData.type === CCR_TYPE.QUARTERLY && currentStepIdentifier === '11') || (this.currentData.type === CCR_TYPE.ANNUAL && currentStepIdentifier === '9')) {
        component = CCR_STEP_COMPONENTS.CREDIT_CREATION_SUMMARY;
      } else if (currentStepIdentifier === 'SEC_88_90') {
        component = CCR_STEP_COMPONENTS.CREDIT_CREATION_AJUSTMENTS;
      } else if (this.currentData.type === CCR_TYPE.ANNUAL  && currentStepIdentifier === 'SUPPORTING_DOCS') {
        component = CCR_STEP_COMPONENTS.CCR_DOCUMENTS
      }
      const subSteps = [];
      if(step.code === 'STEP-SEC_88_90'){
        if(this.currentData.associatedCreditAdjustmentSubSteps && this.currentData.associatedCreditAdjustmentSubSteps.length){
          const underSectionSubsteps = this.currentData.associatedCreditAdjustmentSubSteps.filter(ele=>ele.parentId === step.id)
          sortBy(underSectionSubsteps, ['sequence']).map((subStep, j) => {
            subSteps.push({
              ...this.getSubStepContent(subStep, index, j),
            });
          });
        }
      }

      let _step = {
        ...step,
        name: this.getStepName(step[this.translateService.currentLang]),
        completed: false,
        skipTranslate: true,
        id: index + 1,
        component,
      }

      if (subSteps.length) {
        _step.subSteps = subSteps;
        _step.skipMainStep = true;
        if(step.code === 'STEP-SEC_88_90'){
        _step.skipMainStep = false;

        }
        _step.enabledSubSteps = true;
      }

      return _step;
    });
    this.steps = [...steps];
  }

  public getStepName(val): string {
    const arr = val.split(': ');
    arr.shift();
    return arr.join(': ');
  }

  reSubmitReport(payload): Observable<any> {
    return this.http.post(`${ environment.apiUrl }${ CCR_RE_SUBMIT_REPORT }`, {...payload, action: 'RESUBMIT'});
  }

  getReportByIdToReSubmit(reportId) {
    return this.http.get<any>(`${ environment.apiUrl }${ GET_REPORT_BY_ID_TO_RESUBMIT }${ reportId }`);
  }

  public getDocUploadID() {
    return this.http.get<any>(`${environment.apiUrl}${COMP_REP_DOC_UPLOAD_ID}`);
  }

  public propose(payload) {
    return this.http.post(`${ environment.apiUrl }${CCR_PROPOSE}`, payload)
  }

  getCITableData(payload) {
    return this.http.post(`${ environment.apiUrl }${ CCR_GET_CI_DATA }`, {...payload});
  }

  getDefaultCIsForACCR(payload) {
    return this.http.post(`${ environment.apiUrl }${ CCR_GET_DEFAULTCIS }`, payload);
  }

  public toggleStepsForUnderSections(showStepsForUnderSections: boolean) {
    this.steps = this.steps.map(step => {
      return {
        ...step,
        enabledSubSteps: step.code === 'STEP-SEC_88_90' ? showStepsForUnderSections : step.enabledSubSteps,
      };
    });
  }

  downloadDocumentAPI(templateName: string) {
     const uri = CHARGING_SITE_DOWNLOAD_URI + templateName;
     return  this.uploadDocumentService.downloadDocument(`${ environment.apiUrl }${uri}`);
  }

  public validateCIPathway(action: string, reportData: any): Observable<any> {
    const payload = {
      reportType: CCR_TYPE.ANNUAL,
      ccrId: this.currentData.id,
      year: this.currentData.complianceYear,
      action,
      stepCode: action === 'SAVE' ? this.currentStep.code : undefined
    }
    if ((this.currentData.type === CCR_TYPE.ANNUAL)
      && (reportData[CCR_INVOLVED_IN_ACTIVITIES] || ['SUBMIT', 'RESUBMIT'].includes(action))) {
      return this.http.post<any>(`${ environment.apiUrl }${ CCR_VALIDATE_CI_PATHWAY }`, payload);
    } else {
      return of([]);
    }
  }

}
